<template>
    <div class="parkcont" >
        <div class="Information">
            <div class="img">
                <img :src="parkInfo.projectImg" alt="">
            </div>
            <!-- <div class="title">
                园区信息
            </div>
            <div class="adress">
                <ul>
                    <li>
                        <span class="name">园区地址：</span>
                        <span class="cont u-line-2">{{parkInfo.projectAddress}}</span>
                    </li>
                    <li>
                        <span class="name">辖区面积：</span>
                        <span class="cont">{{parkInfo.projectArea}}㎡</span>
                    </li>
                    <li>
                        <span class="name">电压等级：</span>
                        <span class="cont">{{JSON.parse(parkInfo.projectDetailsInfo)['供电电压']}}kV</span>
                    </li>
                    <li>
                        <span class="name">供电来源：</span>
                        <span class="cont u-line-1">{{JSON.parse(parkInfo.projectDetailsInfo)['供电来源: ']}}</span>
                    </li>
                </ul>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                
            }
        },
        components:{
            
        },
        computed:{
            parkInfo(){
                return this.$store.state.project.projectInfo
            },
        },
        created(){
            if(this.$router.params.tag=='Homepage'){  //工作台默认选中第一个
                this.$router.push(this.$store.state.project.FirstPage.url)
                this.$store.commit("setCurrWorkBench",this.$store.state.project.FirstPage.url)
            }
        },
        watch: {
            "$store.state.project.FirstPage"(n, o) {
                if(this.$router.params.tag=='Homepage'){  //工作台默认选中第一个
                    this.$router.push(n.url)
                    this.$store.commit("setCurrWorkBench",n.url)
                }
            },
        },
        methods:{
            
        }
    }
    </script>
 <<style lang="less" scoped>
 .parkcont{
    background: #ffffff;
    height: 100%;
    padding: 20rem;
    .title{
        font-size: 16rem;
        border-left: 5rem solid #0D94FF;
        height: 18px;
        line-height: 18px;
        padding-left: 6px;
        margin: 10rem 0 10rem 0
    }
    .Information{
        .img{
            .h(700);
            margin-bottom: 20rem;
            img{
                height: 100%;
                width: 100%;
            }
        }
        .adress{
            background: rgba(0,43,102,0.04);
            border-top: 1px solid rgba(0, 0, 0, 0.15);
            li{
                font-size: 16rem;
                line-height: 38rem;
                height: 36rem;
                border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                display: flex;
                align-items: flex-start;
                span{
                    display: inline-block;
                }
                .name{
                    .w(100);
                    text-align: right;
                }
                .cont{
                    // .w(230);
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    flex: 1;
                    padding-right: 10px;
                }
            }
        }
        li:last-child{
            // border:0
        }
    }
}
 </style>